export enum StorageKeys {
  personDetailSelectedAlert = "person/detail/selectedAlert",
  user = "UI_USER",
  locale = "UI_LOCALE",
  preferences = "ui_preferences",
}

const LEGACY_STORAGE_KEYS: Partial<Record<StorageKeys, string>> = {
  [StorageKeys.user]: "PANPAN_UI_USER",
  [StorageKeys.locale]: "PANPAN_LOCALE",
  [StorageKeys.preferences]: "panpan_preferences",
};

export function getStorageItem(key: StorageKeys) {
  const current = localStorage.getItem(key);
  if (current != null) {
    return current;
  }
  const legacyKey = LEGACY_STORAGE_KEYS[key];
  return legacyKey ? localStorage.getItem(legacyKey) : null;
}

export function setStorageItem(key: StorageKeys, value: string) {
  localStorage.setItem(key, value);
  const legacyKey = LEGACY_STORAGE_KEYS[key];
  if (legacyKey) {
    localStorage.removeItem(legacyKey);
  }
}

export function removeStorageItem(key: StorageKeys) {
  localStorage.removeItem(key);
  const legacyKey = LEGACY_STORAGE_KEYS[key];
  if (legacyKey) {
    localStorage.removeItem(legacyKey);
  }
}
